export default {
  modals:{
    items: {},
    active: false
  },
}